import React from 'react'
import METAWATERHEATERJaquar from "../images/META WATER HEATER Jaquar.jpg";
import Terawaterheater_Jaquar from "../images/Tera Water Heater JAQUAR.jpg";
import sanitaryware from "../images/SANITARYWARE.jpg";
import sanitarywarejaquar from "../images/Sanitaryware black JAQUAR.jpg";

import sanitaryweargreyJaquar from "../images/Sanitarywear Grey Black color.jpg";
import thegraceofgrey_Jaquar from "../images/The Grace of Grey _Jaquar.jpg";
import sanitarywaremattmatters from "../images/Matt Matters Jaquar.jpg";
import sanitarywarejaquarproducts from "../images/Jaquar_Sanitarywear.jpg";

import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import jaquarvideo from "../images/Jaquar Video.mp4";

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'



import alexus from "../images/Alexus.jpg"
import bannet from "../images/Bannet.jpg";
import barndonpearl from "../images/Barndol.jpg";
import Lucasmarble from "../images/Lucas Marble.jpg";

function Jaquarpage() {
    return (
        <div>


<div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={METAWATERHEATERJaquar} className="card-img-top" alt="Burberrylux" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-2">Meta Water Heater </h5>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={Terawaterheater_Jaquar} className="card-img-top" alt="briellagold" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-2">Terra Water Heater</h5>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={sanitaryware} className="card-img-top" alt="faimacoffee" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-2">Grey Matt Sanitaryware </h5>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={sanitarywarejaquar} className="card-img-top" alt="swedencopper" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-2" >Grey Matt Sanitaryware
                              </h5>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



<div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={sanitaryweargreyJaquar} className="card-img-top" alt="thegraceofgrey_Jaquar" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-2">Grey Matt Sanitaryware </h5>


                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={thegraceofgrey_Jaquar} className="card-img-top" alt="thegraceofgrey_Jaquar" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-2">Grey Matt Sanitaryware</h5>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className="card">
                                        <Zoom>
                                            <img src={sanitarywaremattmatters} className="card-img-top" alt="sanitarywaremattmatters" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-2">Grey Matt Sanitaryware </h5>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                            
                                        <div className="card">
                                            <Zoom>
                                                <img src={sanitarywarejaquarproducts} className="card-img-top" alt="swedencopper" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-2" >Grey Matt Sanitaryware
                              </h5>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>

                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



          


            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-1">

                            <Video Play loop onCanPlayThrough={() => {
                                console.log('video play')
                            }}>
                                <source src={jaquarvideo} type="video/webm" />
                            </Video>
                        </div>



                    </div>
                </div>
            </div>
        </div>
    )
}

export default Jaquarpage